export const SocialGroupForPointsLiterals = [
  'Facebook',
  'GalateaFBPage',
  'Instagram',
  'InstagramGalateaTV',
  'TikTokGalateaTV',
  'TikTok',
  'Discord',
  'Inkitt',
  'GalateaTV',
  'TestReduceFreeChapters',
  'Reddit',
  'PushNotifications',
] as const;

export type SocialGroupForPoints = (typeof SocialGroupForPointsLiterals)[number];
